import React, {Component} from 'react';
import {UncontrolledCarousel} from 'reactstrap';
import {getEnv} from "../../env";
import {Translate} from 'react-localize-redux';
import {connect} from 'react-redux';

class Carousel extends Component {
	
	render() {
		const gallery = this.props.images.filter(i => i.type === "gallery");
		
		const items = gallery.map(image => {
			return {
				src: getEnv('S3_ASSETS_BUCKET') + '/' + image.path,
				altText: '',
				caption: '',
			};
		});
		return (
			<Translate>
				{({translate}) => (
					<div className={"" + this.props.className}>
						<UncontrolledCarousel autoPlay={false} items={items}/>
					</div>
				)}
			
			</Translate>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		images: store.adminImages.images,
	};
};

export default connect(mapStateToProps)(Carousel);



// WEBPACK FOOTER //
// ./src/04-containers/Carousel/index.js